import { userEndpoint } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export default function useCurrentUser(userId: number | null) {
  const query = useQuery({
    queryKey: ["get-user", userId],
    enabled: !!userId,
    queryFn: async () => {
      if (!userId) return null;
      const res = await axiosInstance.get(`${userEndpoint}/${userId}`);
      return res.data.user;
    },
    // This fetch backs the Edit-User modal the admin just opened. The API
    // returns 503 "service is busy" on a transient pg-pool timeout precisely
    // so the client can retry while the pool drains — but the global query
    // config sets retry:0, so a single blip left the modal stuck/blank.
    // Retry transient server/network errors here (never 4xx).
    retry: (failureCount, error: any) => {
      const status = error?.response?.status;
      if (status && status >= 400 && status < 500) return false;
      return failureCount < 3;
    },
    retryDelay: (attempt) => Math.min(600 * 2 ** attempt, 4000),
  });

  return {
    user: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
